import { useEffect, useRef } from 'react';
import { Page, PageType } from '@common/entities';

import { useValidateSpecialsBeforePayment } from './useValidateSpecialsBeforePayment';

type SummaryPage = Pick<Page, 'id' | 'type'> | undefined;

/**
 * Validates selected specials when Summary is entered, including URL and resumed navigation.
 * Validation is intentionally non-blocking so a slow validation request cannot prevent Summary
 * from rendering.
 */
export function usePaymentPageEntryGuard(currentPage: SummaryPage): boolean {
  const validateSpecialsBeforePayment = useValidateSpecialsBeforePayment();
  const startedSummaryPageIdRef = useRef<string | undefined>();
  const summaryPageId = currentPage?.type === PageType.Summary ? currentPage.id : undefined;

  useEffect(() => {
    if (!summaryPageId) {
      startedSummaryPageIdRef.current = undefined;
      return () => undefined;
    }

    if (startedSummaryPageIdRef.current === summaryPageId) return () => undefined;

    startedSummaryPageIdRef.current = summaryPageId;

    validateSpecialsBeforePayment().catch(() => undefined);

    return () => undefined;
  }, [summaryPageId, validateSpecialsBeforePayment]);

  return false;
}
